import React, { Component } from 'react'
import clone from 'lodash/cloneDeep'
import set from 'lodash/set'
import { observify } from './helper.js'

export default class Setter extends Component {
  state = {
    draft: false,
    result: {}
  };
  componentDidMount = () => {
    this.initData();
  };

  initData() {
    const { data } = this.props;
    const draft = observify(data, this.handleSetting);
    this.setState({
      draft,
      result: clone(data)
    });
  }

  handleSetting = (scope, value) => {
    const { draft, result } = this.state;
    set(result, scope, value);

    this.setState({
      draft: observify(
        {
          ...draft
        },
        this.handleSetting,
        [],
        false
      ),
      result: result
    });
  };

  getResult() {
    return this.state.result;
  }

  reset() {
    this.initData();
  }

  render() {
    const { data, children, ...others } = this.props;
    const { draft, result } = this.state;
    return draft ? children(draft, result, others) : "";
  }
}
